import i18next from 'i18next';
import * as React from 'react';
import { StandardLocalWidget, any, fromJSX, nothing } from "widgets-for-react";
import { subscriptionSelectorWidget } from "../../forms/subscriptionSelector/subscriptionSelectorWidget";
import { RootLayout } from "../../site/root/rootLayout";
import { newSubscriptionInputUpdaters } from "../newSubscription/newSubscriptionState";
import { SubscriptionLayout } from "../subscriptionLayout";
import { SubscriptionState, subscriptionUpdaters } from "../subscriptionState";
import { initializePIIData, PIIData } from 'utils/datalayer';

export const editSubscriptionWidget: StandardLocalWidget<SubscriptionState> = currentState =>
  currentState.kind != "edit subscription flow" ? nothing() :
    any([
      currentState.subscribe.kind == "loaded" ?
      fromJSX(setState =>
        currentState.subscribe.kind == "loaded" ? 
          currentState.subscribe.value.Kind == "Redirect" ?
            <SubscriptionLayout.RedirectToPsp
              variant="other"
              redirectUrl={currentState.subscribe.value.RedirectUrl}
            />
          : currentState.subscribe.value.Kind == "Success" ?
            <SubscriptionLayout.ThankYou 
              variant="subscription-success"
              subscriptionState={currentState}
              thankYouMessage={i18next.t("subscription:SubscriptionChangedThankYouMessage")}
            />
          : <SubscriptionLayout.FailureOrCancel 
              variant="subscription-failure"
            />
        : <></>
      )
    :
    fromJSX(setState =>{
      
      const piiData = initializePIIData(currentState.userSubscriptions)

      return (
      <>
          {
            currentState.lookupData.kind == "loaded" ?
              subscriptionSelectorWidget(currentState.lookupData.value.Subscriptions, 'account-details', piiData)(currentState.newSubscriptionInput.subscriptionSelectorState)
                .map(newSubscriptionInputUpdaters.subscriptionSelectorState)
                .map(subscriptionUpdaters.newSubscriptionInput)
                .run(setState)
            :
              <RootLayout.Loader showText hasWrapper />
          }
        <SubscriptionLayout.ActionAndBackButtons 
          back={() => setState(subscriptionUpdaters.overview)}
          action={() => setState(subscriptionUpdaters.invokeSubscribeNowApi)}
          actionText={i18next.t("subscription:Submit")}
          actionDisabled={!currentState.newSubscriptionInput.subscriptionSelectorState.isValid()}
          />
      </>
      )})
    ])
